var R_UTILS = {
    isEmpty: function(object) { return R.isEmpty(object); },
    isNil: function(object) { return R.isNil(object); },
    isEmptyOrNil: function(object) { return R.isNil(object) | R.isEmpty(object); },
    makeInt: function(item) { return parseInt(item) },
};

export default R_UTILS;
